"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateDunningLetter = class CreateDunningLetter extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    numbering;
    async $$load_numbering() {
        return this.$fn.fetch('read_numbering', { parameters: { id: 'sys.dunning_letter' } });
    }
    startingReferenceNumber;
    async $$load_startingReferenceNumber() {
        return this.numbering.info.next_value;
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['numbering', 'startingReferenceNumber', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                numbering: null,
                startingReferenceNumber: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Create dunning letters"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7548_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_register_7554_getActionArgs($event) {
        return {
            name: "resultLength",
            value: $event.data.response.data ? $event.data.response.data.length : 0,
        };
    }
    async act_1040167445267876_notification_7556_getActionArgs($event) {
        return {
            message: this.$fn.ngettext("One dunning letter created.", "${n} dunning letters created.", $event.data.resultLength),
        };
    }
    async act_1040167445267876_notification_7556_getWhen($event) {
        return $event.data.resultLength > 0;
    }
    async act_1040167445267876_closeModal_7558_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_7560_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_1040167445267876_request_7552_getActionArgs($event) {
        return {
            operation: "create_dunning_letter",
            data: _.chain(this.items)
                .groupBy(p => `${p.issuer.id}${p.client_id}`)
                .map((items, g) => ({
                company: {
                    id: items[0].issuer.id
                },
                client: {
                    id: items[0].client_id
                },
                items: _.map(items, p => ({ invoice_number: p.invoice_number }))
            }))
                .value(),
            parameters: {
                "starting-reference-number": this.startingReferenceNumber,
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7548 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7548_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7547 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7548,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7547],
        });
        const act_2248226175642056_closeComponent_7550 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_7549 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7550,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7549],
        });
        const act_1040167445267876_register_7554 = new core_1.actions.RegisterAction({
            actionArgs: this.act_1040167445267876_register_7554_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7553 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_register_7554,
            event: "success",
            displayName: "register",
        });
        const act_1040167445267876_notification_7556 = new core_1.actions.NotificationAction({
            actionArgs: this.act_1040167445267876_notification_7556_getActionArgs,
            when: this.act_1040167445267876_notification_7556_getWhen,
            events: [],
        });
        const evh_1040167445267876_success_7555 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_notification_7556,
            event: "success",
            displayName: "notification",
        });
        const act_1040167445267876_closeModal_7558 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_7558_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7557 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_7558,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_reloadSlickgrid_7560 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_7560_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7559 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_7560,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_request_7552 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_7552_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_7553, evh_1040167445267876_success_7555, evh_1040167445267876_success_7557, evh_1040167445267876_success_7559],
        });
        const evh_1040167445267876_submit_7551 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_7552,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_7551],
        });
        const act_1419464017721962_closeComponent_7562 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_7561 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_7562,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_7561],
        });
        return {
            act_7315092382398562_closeModal_7548,
            evh_7315092382398562_close_7547,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7550,
            evh_2248226175642056_close_7549,
            evh_2248226175642056_close,
            act_1040167445267876_register_7554,
            evh_1040167445267876_success_7553,
            act_1040167445267876_notification_7556,
            evh_1040167445267876_success_7555,
            act_1040167445267876_closeModal_7558,
            evh_1040167445267876_success_7557,
            act_1040167445267876_reloadSlickgrid_7560,
            evh_1040167445267876_success_7559,
            act_1040167445267876_request_7552,
            evh_1040167445267876_submit_7551,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_7562,
            evh_1419464017721962_clickPreventStop_7561,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_7552,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        default: null,
    }),
    __metadata("design:type", typeof (_a = typeof list !== "undefined" && list) === "function" ? _a : Object)
], CreateDunningLetter.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateDunningLetter.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateDunningLetter.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateDunningLetter.prototype, "onSize", null);
CreateDunningLetter = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateDunningLetter);
exports.default = CreateDunningLetter;
vue_property_decorator_1.Vue.component("CreateDunningLetter", CreateDunningLetter);
